import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ViewEnquiryModal = React.lazy(() => import("./view-enquiry.modal"));

const ViewEnquiry: iModalProps<typeof ViewEnquiryModal, { enquiryId: string }> =
  {
    name: "view-enquiry",
    component: GenerateModalWithSuspense(ViewEnquiryModal),
  };

export default ViewEnquiry;
